











































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { PageItem, FieldItem, RecogField, Pos, SheetField } from "../../modules/teacher/RecogPositionEdit"
// @ts-ignore
import VueDragResize from "vue-drag-resize";

const DirectionEnum = Object.freeze({Horizontal: 1, VerticalLeft: 2, VerticalRight: 3});
const ModeEnum = Object.freeze({Waku: 1, Delete: 2, Assign: 3,});

export interface Data {
  tabNo: number
  currentPage: number
  sheet_group_key: string
  sheet: any
  sheetFields: SheetField[]
  pageItems: PageItem[]
  scale: number
  isMouseDown: boolean
  beginPos: Pos
  baseFieldItem: FieldItem
  currentFieldItem: FieldItem | null
  currentRecogField: RecogField | null
  assignRecogField: RecogField | null
  fieldItemCache: FieldItem | null
  borderWidth: number
  errors: string[]
  DirectionEnum: Readonly<{Horizontal: number;VerticalLeft: number; VerticalRight: number;}>
  ModeEnum: Readonly<{Waku: number;Delete: number;Assign: number;}>
  isShiftPressed: boolean
  isCtrlPressed: boolean
  isMultiSelect: boolean
  isMouseOnImageArea: boolean
  multiSelectedFieldItems: FieldItem[]
  recogFieldNamePos: Pos
  key: number
  mode: number
  helpFields: any[]
  isExistsMark: boolean
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 7,
      currentPage: 1,
      sheet_group_key: "",
      sheet: null,
      sheetFields: [],
      pageItems: [],
      scale: 0.5,
      isMouseDown: false,
      beginPos: new Pos(0, 0),
      baseFieldItem: new FieldItem(),
      currentFieldItem: null,
      currentRecogField: null,
      assignRecogField: null,
      fieldItemCache: null,
      borderWidth: 2,
      errors: [],
      DirectionEnum: DirectionEnum,
      ModeEnum: ModeEnum,
      isShiftPressed: false,
      isCtrlPressed: false,
      isMultiSelect: false,
      isMouseOnImageArea: false,
      multiSelectedFieldItems: new Array<FieldItem>(),
      recogFieldNamePos: new Pos(0, 0),
      key: 1,
      mode: ModeEnum.Waku,
      helpFields: [
        { key: "マウスドラッグ", img: require("@/assets/images/icon_cursor.png"), description: "枠を作成" },
        { key: "Back Spaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "選択中の枠を削除" },
        { key: "Cキー", img: require("@/assets/images/keyboard_C.png"), description: "選択中の枠をコピー" },
        { key: "Shiftキー + マウスドラッグ", img: require("@/assets/images/keyboard_Shift.png"), description: "複数の枠を選択" },
      ],
      isExistsMark: false,
    });

    /****************************************
     * 現在表示中のページ情報
     ****************************************/

    const currentPageItem = computed(() => {
      return state.pageItems.length > 0 ? state.pageItems[state.currentPage - 1] : null;
    });

    /****************************************
     * 枠設定数
     ****************************************/

    const allFieldItems = computed(() => {
      // @ts-ignore
      return [].concat.apply([], state.pageItems.map(x => x.fieldItems));
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentW = computed(() => {
      return currentPageItem.value ? currentPageItem.value.baseWidth * state.scale : 0;
    });

    /****************************************
     * 倍率を加味した画像の横幅
     ****************************************/

    const parentH = computed(() => {
      return currentPageItem.value ?  currentPageItem.value.baseHeight * state.scale : 0;
    });

    /****************************************
     * 画像のサイズCSSスタイル
     ****************************************/

    const sizeStyle = computed(() => {
      let style: any = {};
      style["width"] = `${parentW.value}px`;
      style["height"] = `${parentH.value}px`;
      return style;
    });

    /****************************************
     * 点線枠のCSSスタイル
     ****************************************/

    const baseFieldStyle = computed(() => {
      let style: any = {};
      style["left"] = `${state.baseFieldItem.x * state.scale}px`;
      style["top"] = `${state.baseFieldItem.y * state.scale}px`;
      style["width"] = `${state.baseFieldItem.width * state.scale}px`;
      style["height"] = `${state.baseFieldItem.height * state.scale}px`;
      style["display"] = state.baseFieldItem.width > 0 && state.baseFieldItem.height > 0 ? "block" : "none";
      style["border-color"] = state.isMultiSelect ? "blue" : "red";
      return style;
    });

    /****************************************
     * 手動設問割当て時にカーソルに追従する設問名のCSSスタイル
     ****************************************/

    const recogFieldNamePosStyle = computed(() => {
      let style: any = {};
      style["left"] = `${state.recogFieldNamePos.x + 20}px`;
      style["top"] = `${state.recogFieldNamePos.y}px`;
      return style;
    });

    const isSelected = (fieldItem: FieldItem) => {
      if(state.multiSelectedFieldItems.length > 0){
        return state.multiSelectedFieldItems.indexOf(fieldItem) != -1;
      }else if(state.mode != state.ModeEnum.Assign){
        return state.currentFieldItem == fieldItem;
      }else{
        return fieldItem.recogField && fieldItem.recogField.id == state.assignRecogField.id;
      }
    };

    /****************************************
     * 画面サイズに合わせてレイアウト整形
     ****************************************/

    const adjustHeight = () => {
      context.root.$nextTick(() => {
        const winH = window.innerHeight;
        const tableArea = document.getElementById("table-area");
        const imageArea = document.getElementById("image-area");

        if(tableArea != null && imageArea != null){
          tableArea.style.height = (winH - tableArea.offsetTop) + "px";
          imageArea.style.height = (winH - imageArea.offsetTop) + "px";
        }
      });
    };

    /****************************************
     * 画像を表示エリアの横幅に合わせる
     ****************************************/

    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth - 30;
        state.scale = imageAreaW / currentPageItem.value.baseWidth;
        adjustHeight();
      }
    };

    /****************************************
     * 拡大ボタン押下
     ****************************************/

    const scaleUp = () => {
      state.scale += 0.05;
      adjustHeight();
    };

    /****************************************
     * 縮小ボタン押下
     ****************************************/

    const scaleDown = () => {
      if(state.scale > 0.2){
        state.scale -= 0.05;
        adjustHeight();
      }
    };

    /****************************************
     * 画像エリアpointerdown
     ****************************************/

    const imageAreaPointerDown = (e: PointerEvent) => {
      const element = (e.target as HTMLElement);
      if(element.id == "image-wrap" && (state.isShiftPressed || state.mode == state.ModeEnum.Waku)){
        element.setPointerCapture(e.pointerId);
        state.isMouseDown = true;
        state.beginPos = new Pos(e.offsetX / state.scale, e.offsetY / state.scale);
        clearCurrentItem();
        state.isMultiSelect = state.isShiftPressed;
      }else if(element.id == "image-wrap" && state.mode == state.ModeEnum.Assign){
        clearCurrentItem();
      }
    }

    /****************************************
     * 画像エリアpointermove
     ****************************************/

    const imageAreaPointerMove = (e: PointerEvent) => {
      
      const element = (e.target as HTMLElement);
      if(state.isMouseDown){
        let x = 0, y = 0;
        if(element.id == "image-wrap"){
          x = e.offsetX / state.scale;
          y = e.offsetY / state.scale;
        }
        
        if(x > state.beginPos.x){
          state.baseFieldItem.x = state.beginPos.x;
          state.baseFieldItem.width = x - state.beginPos.x;
        }else{
          state.baseFieldItem.x = x;
          state.baseFieldItem.width = state.beginPos.x - x;
        }

        if(y > state.beginPos.y){
          state.baseFieldItem.y = state.beginPos.y;
          state.baseFieldItem.height = y - state.beginPos.y;
        }else{
          state.baseFieldItem.y = y;
          state.baseFieldItem.height = state.beginPos.y - y;
        }
      }else if(state.mode == state.ModeEnum.Assign){
        let x = 0, y = 0;
        if(element.id == "image-wrap"){
          x = e.offsetX;
          y = e.offsetY;
        }else if(element.className.includes("rect-div")){
          x = e.offsetX + element.offsetLeft + 2;
          y = e.offsetY + element.offsetTop + 2;
        }else if(element.className.includes("rect-name")){
          const parent = element.parentNode as HTMLElement;
          x = e.offsetX + parent.offsetLeft + 2;
          y = e.offsetY + parent.offsetTop + 2;
        }
        state.recogFieldNamePos = new Pos(x, y);
        state.isMouseOnImageArea = true;
      }
    }

    /****************************************
     * 画像エリアpointerup
     ****************************************/

    const imageAreaPointerUp = (e: PointerEvent) => {
      if(state.isMouseDown){
        (e.target as HTMLElement).releasePointerCapture(e.pointerId);
        state.isMouseDown = false;
        if(state.isMultiSelect){
          setMultiSelectFields();
        }else{
          addFieldItem();
        }
      }
    }

    /****************************************
     * 画像エリアpointerleave
     ****************************************/

    const imageAreaPointerLeave = (e: PointerEvent) => {
      if(state.isMouseDown){
        (e.target as HTMLElement).releasePointerCapture(e.pointerId);
        state.isMouseDown = false;
        if(state.isMultiSelect){
          setMultiSelectFields();
        }else{
          addFieldItem();
        }
      }
      state.isMouseOnImageArea = false;
    }

    /****************************************
     * 枠複数選択 点線枠内の設問枠を選択
     ****************************************/

    const setMultiSelectFields = () => {

      clearCurrentItem();

      currentPageItem.value.fieldItems.forEach((x: FieldItem) => {

        let isSelected = true;
        if(x.x < state.baseFieldItem.x){
          isSelected = false;
        }
        if(x.y < state.baseFieldItem.y){
          isSelected = false;
        }
        if(x.x + x.width > state.baseFieldItem.x + state.baseFieldItem.width){
          isSelected = false;
        }
        if(x.y + x.height > state.baseFieldItem.y + state.baseFieldItem.height){
          isSelected = false;
        }
        if(isSelected){
          //x.isActive = false;
          state.multiSelectedFieldItems.push(x);
        }
      });

      // 点線枠リセット
      state.baseFieldItem.x = 0;
      state.baseFieldItem.y = 0;
      state.baseFieldItem.width = 0;
      state.baseFieldItem.height = 0;
    }

    /****************************************
     * 枠情報追加
     ****************************************/
    
    const addFieldItem = () => {
      if(state.baseFieldItem.width > 20 && state.baseFieldItem.height > 20){
        // 点線枠から位置・サイズ情報を抽出しページ配下の枠追加
        const fieldItem = new FieldItem();
        fieldItem.key = state.key++;
        fieldItem.x = state.baseFieldItem.x;
        fieldItem.y = state.baseFieldItem.y;
        fieldItem.width = state.baseFieldItem.width;
        fieldItem.height = state.baseFieldItem.height;
        currentPageItem.value.fieldItems.push(fieldItem);
        changeCurrentFieldItem(fieldItem);
      }
      
      // 点線枠リセット
      state.baseFieldItem.x = 0;
      state.baseFieldItem.y = 0;
      state.baseFieldItem.width = 0;
      state.baseFieldItem.height = 0;
    };

    const editTargetFieldItems = computed(() => {
      return state.multiSelectedFieldItems.length > 0 ? state.multiSelectedFieldItems : [state.currentFieldItem];
    });

    /****************************************
     * 枠のドラッグ中イベント
     ****************************************/

    const dragging = (rect: any) => {

      // 単一選択の場合は処理終了
      if(state.multiSelectedFieldItems.length == 0){
        return;
      }

      const addX = (rect.left / state.scale) - state.fieldItemCache.x;
      const addY = (rect.top / state.scale) - state.fieldItemCache.y;

      // 複数選択中の枠をドラッグに追随させる
      editTargetFieldItems.value.forEach(x => {
        x.x += addX;
        x.y += addY;
      });

      state.fieldItemCache.x = rect.left / state.scale;
      state.fieldItemCache.y = rect.top / state.scale;
    }

    /****************************************
     * 枠のドラッグ終了時イベント
     ****************************************/
    
    const dragStop = (rect: any) => {

      if(state.multiSelectedFieldItems.length == 0){

        const fieldItem = editTargetFieldItems.value[0];

        if(rect.left < 0){
          fieldItem.x = 0;
        }else if(rect.left + rect.width > parentW.value){
          fieldItem.x = (parentW.value - rect.width) / state.scale;
        }else{
          fieldItem.x = rect.left / state.scale;
        }

        if(rect.top < 0){
          fieldItem.y = 0;
        }else if(rect.top + rect.height > parentH.value){
          fieldItem.y = (parentH.value - rect.height) / state.scale;
        }else{
          fieldItem.y = rect.top / state.scale;
        }
      }else{
        // 複数選択時のドラッグ終了処理
        const addX = (rect.left / state.scale) - state.fieldItemCache.x;
        const addY = (rect.top / state.scale) - state.fieldItemCache.y;

        editTargetFieldItems.value.forEach(x => {

          x.x += addX;
          x.y += addY;

          if(x.x < 0){
            x.x = x.x == 1 ? 0 : 1;
          }else if((x.x + x.width) * state.scale > parentW.value){
            x.x = x.x == (parentW.value - (x.width * state.scale)) / state.scale ? (parentW.value - (x.width * state.scale)) / state.scale - 1 : (parentW.value - (x.width * state.scale)) / state.scale;
          }

          if(x.y < 0){
            x.y = x.y == 1 ? 0 : 1;
          }else if((x.y + x.height) * state.scale > parentH.value){
            x.y = (x.y + x.height) * state.scale == parentH.value ? parentH.value - (x.height * state.scale) - 1 : parentH.value - (x.height * state.scale);
            ;
          }
        });
      }
    };

    /****************************************
     * 枠のリサイズ中イベント
     ****************************************/

    const resizing = (rect: any) => {

      // 単一選択の場合は処理終了
      if(state.multiSelectedFieldItems.length == 0){
        return;
      }

      const addX = (rect.left / state.scale) - state.fieldItemCache.x;
      const addY = (rect.top / state.scale) - state.fieldItemCache.y;

      // 複数選択中の枠をドラッグに追随させる
      editTargetFieldItems.value.forEach(x => {
        x.width = rect.width / state.scale;
        x.height = rect.height / state.scale;
        x.x += addX;
        x.y += addY;
      });

      state.fieldItemCache.x = rect.left / state.scale;
      state.fieldItemCache.y = rect.top / state.scale;
      state.fieldItemCache.width = rect.width / state.scale;
      state.fieldItemCache.height = rect.height / state.scale;
    }

    /****************************************
     * 枠のリサイズ終了時イベント
     ****************************************/
    
    const resizeStop = (rect: any) => {

      if(state.multiSelectedFieldItems.length == 0){

        const fieldItem = editTargetFieldItems.value[0];

        if(rect.left < 0){
          fieldItem.width = fieldItem.width + fieldItem.x;
          fieldItem.x = 0;
        }else if(rect.left + rect.width > parentW.value){
          fieldItem.width = (parentW.value - rect.left) / state.scale;
        }else{
          fieldItem.width = rect.width / state.scale;
          fieldItem.x = rect.left / state.scale;
        }

        if(rect.top < 0){
          fieldItem.height = fieldItem.height + fieldItem.y;
          fieldItem.y = 0;
        }else if(rect.top + rect.height > parentH.value){
          fieldItem.height = (parentH.value - rect.top) / state.scale;
        }else{
          fieldItem.height = rect.height / state.scale;
          fieldItem.y = rect.top / state.scale;
        }
      }else{
        const addX = (rect.left / state.scale) - state.fieldItemCache.x;
        const addY = (rect.top / state.scale) - state.fieldItemCache.y;

        editTargetFieldItems.value.forEach(x => {

          x.width = rect.width / state.scale;
          x.height = rect.height / state.scale;
          x.x += addX;
          x.y += addY;

          if(x.x < 0){
            x.x = x.x == 1 ? 0 : 1;
          }else if((x.x + x.width) * state.scale > parentW.value){
            x.x = x.x == (parentW.value - (x.width * state.scale)) / state.scale ? (parentW.value - (x.width * state.scale)) / state.scale - 1 : (parentW.value - (x.width * state.scale)) / state.scale;
          }

          if(x.y < 0){
            x.y = x.y == 1 ? 0 : 1;
          }else if((x.y + x.height) * state.scale > parentH.value){
            x.y = (x.y + x.height) * state.scale == parentH.value ? parentH.value - (x.height * state.scale) - 1 : parentH.value - (x.height * state.scale);
            ;
          }
        });
      }
    };

    /****************************************
     * 枠をクリック
     ****************************************/

    const fieldClick = (fieldItem: FieldItem) => {

      if(state.mode == state.ModeEnum.Delete){
        deleteFieldItem(fieldItem);
      }else if(state.mode == state.ModeEnum.Assign){
        // 枠に設問を割り当てる
        allFieldItems.value.filter(x => x.recogField && x.recogField.id == state.assignRecogField.id).forEach(x => x.recogField = null);
        fieldItem.recogField = state.assignRecogField;

        changeCurrentFieldItem(fieldItem);
        const nextIdx = currentPageItem.value.recogFields.indexOf(state.assignRecogField) + 1;
        
        if(nextIdx + 1 > currentPageItem.value.recogFields.length){
          // 最後の設問だった場合、手動モードをOFF
          state.assignRecogField = null;
          state.mode = state.ModeEnum.Waku;
        }else{
          // 次の設問へ切り替え
          state.assignRecogField = currentPageItem.value.recogFields[nextIdx];
          scrollTableArea(state.assignRecogField);
        }
      }else{
        if(state.currentFieldItem || (!state.currentFieldItem && state.multiSelectedFieldItems.length == 0)){
          clearCurrentItem();
          changeCurrentFieldItem(fieldItem);
          scrollTableArea(fieldItem.recogField);
        }else if(state.multiSelectedFieldItems.filter(x => x.key == fieldItem.key).length == 0){
          // 複数選択中の枠以外をクリックした場合、選択中の複数枠の選択をクリアしてクリックした枠に選択変更
          // 選択変更するだけだと選択中の複数枠にリサイズ用要素が残ってしまうため一旦配列をクリアしてから再格納し直している
          const fieldItems = currentPageItem.value.fieldItems.filter(x => x != fieldItem).map(x => x);
          currentPageItem.value.fieldItems = [fieldItem];
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
            clearCurrentItem();
            changeCurrentFieldItem(fieldItem);
          });
        }else{
          // 複数選択中の枠から一つクリックした場合
          const fieldItems = currentPageItem.value.fieldItems.filter(x => x != fieldItem).map(x => x);
          currentPageItem.value.fieldItems = [fieldItem];
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
          });
        }

        state.fieldItemCache = fieldItem;
      }
    };

    /****************************************
     * 一覧の行クリック
     ****************************************/
    
    const trClick = (recogField: RecogField) => {
      
      if(state.mode == state.ModeEnum.Assign){
        state.assignRecogField = recogField;
      }else{
        changeCurrentRecogField(recogField);
      }
      scrollImageArea(recogField);
    };

    /****************************************
     * 一覧スクロール
     ****************************************/

    const scrollTableArea = (recogField: RecogField) => {
      if(!recogField){
        return;
      }
      const scrollArea = document.getElementById("table-area");
      const trArea = document.getElementById(`tr-${recogField.id}`);

      const scrollAreaHeight = scrollArea.offsetHeight;
      const scrollAreaTop = scrollArea.scrollTop;
      const scrollAreaBottom = scrollAreaTop + scrollAreaHeight;
      const trTop = trArea.offsetTop;
      const trBottom = trArea.offsetTop + trArea.offsetHeight;

      if(scrollAreaTop > trTop){
        scrollArea.scrollTop -= trArea.offsetHeight;
      }else if(scrollAreaBottom < trBottom){
        scrollArea.scrollTop += trArea.offsetHeight;
      }
    }

    /****************************************
     * 枠までスクロール
     ****************************************/

    const scrollImageArea = (recogField: RecogField) => {
      const fieldItem = currentPageItem.value.fieldItems.filter(x => x.recogField == recogField)
      if(fieldItem.length == 0){
        return;
      }

      const rectElement = document.getElementById(`${fieldItem[0].key}`);
      const imageArea = document.getElementById("image-area");

      const imageAreaWidth = imageArea.offsetWidth;
      const imageAreaHeight = imageArea.offsetHeight;
      const imageAreaTop = imageArea.scrollTop;
      const imageAreaBottom = imageAreaTop + imageAreaHeight;
      const imageAreaLeft = imageArea.scrollLeft;
      const imageAreaRight = imageArea.scrollLeft + imageAreaWidth;
      const rectTop = rectElement.offsetTop;
      const rectBottom = rectElement.offsetTop + rectElement.offsetHeight;
      const rectLeft = rectElement.offsetLeft;
      const rectRight = rectElement.offsetLeft + rectElement.offsetWidth;

      let fromTop = imageAreaTop;
      let toTop = imageAreaTop;
      let fromLeft = imageAreaLeft;
      let toLeft = imageAreaLeft;

      if(imageAreaTop > rectTop || imageAreaBottom < rectBottom){
        toTop = rectTop - (imageAreaHeight / 3);
      }

      if(imageAreaLeft > rectLeft || imageAreaRight < rectRight){
        toLeft = rectLeft - (imageAreaWidth / 3);
      }

      if(fromTop != toTop || fromLeft != toLeft){
        Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, imageArea);
      }
    }

    /****************************************
     * モード変更
     ****************************************/

    const changeMode = (mode: number) => {
      
      if(state.mode == mode){
        return;
      }
      
      if(mode == state.ModeEnum.Assign){
        state.assignRecogField = state.currentRecogField ? state.currentRecogField : currentPageItem.value.recogFields[0];
      }
      clearCurrentItem();
      state.mode = mode;
      (document.activeElement as HTMLElement).blur();
    }
    
    /****************************************
     * 枠情報削除
     ****************************************/
    
    const deleteFieldItem = (fieldItem: FieldItem) => {
      const fieldItems = currentPageItem.value.fieldItems.filter((x: FieldItem) => x != fieldItem && !state.multiSelectedFieldItems.includes(x));
      currentPageItem.value.fieldItems = fieldItems;
      state.currentFieldItem = null;
      state.currentRecogField = null;
    };

    /****************************************
     * 選択中の枠変更
     ****************************************/
    
    const changeCurrentFieldItem = (fieldItem: FieldItem) => {
      clearCurrentItem();
      fieldItem.isActive = true;
      state.currentFieldItem = fieldItem;
      if(fieldItem.recogField != null){
        state.currentRecogField = fieldItem.recogField;
      }
    };

    /****************************************
     * 選択中の設問変更
     ****************************************/

    const changeCurrentRecogField = (recogField: RecogField) => {
      state.currentRecogField = recogField;
      state.currentFieldItem = null;

      allFieldItems.value.forEach(x => {
        if(x.recogField && x.recogField.id == recogField.id){
          x.isActive = true;
          state.currentFieldItem = x;
        }else{
          x.isActive = false;
        }
      });
    }

    /****************************************
     * 枠設定完了判定
     ****************************************/

    const isFieldSettingCompleted = (recogField: RecogField) => {
      return allFieldItems.value.filter(x => x.recogField && x.recogField.id == recogField.id).length > 0;
    }

    /****************************************
     * 枠選択情報クリア
     ****************************************/
    
    const clearCurrentItem = () => {
      state.currentFieldItem = null;
      state.currentRecogField = null;
      state.multiSelectedFieldItems = [];
      state.pageItems[state.currentPage - 1].fieldItems.forEach((x: FieldItem) => x.isActive = false);
    };

    /****************************************
     * 枠情報リセット
     ****************************************/
    
    const resetFieldItems = () => {
      if(!window.confirm("設定した枠を全て削除します。よろしいですか？")){
        return;
      }
      state.pageItems.forEach(x => x.fieldItems = new Array<FieldItem>());
      state.currentFieldItem = null;
    };

    /****************************************
     * 設問割当て自動設定
     ****************************************/
    
    const autoAssignRecogFields = (direction: number) => {

      // 割当対象取得 範囲指定の場合は範囲内の枠、指定なしの場合はページ内の全ての枠が対象
      let assignTargets = state.multiSelectedFieldItems.length > 0 ? state.multiSelectedFieldItems : currentPageItem.value.fieldItems;

      assignTargets.forEach(x => {
        x.recogField = null;
      });

      if(state.assignRecogField == null || state.multiSelectedFieldItems.length == 0){
        state.assignRecogField = currentPageItem.value.recogFields[0];
      }

      setSortNo(assignTargets, 1, direction);
      for(const fieldItem of assignTargets.sort((a: FieldItem, b: FieldItem) => a.sortNo - b.sortNo)){
        allFieldItems.value.filter(x => x.recogField && x.recogField.id == state.assignRecogField.id).forEach(x => x.recogField = null);
        fieldItem.recogField = state.assignRecogField;
        const nextIdx = currentPageItem.value.recogFields.indexOf(state.assignRecogField) + 1;
        if(nextIdx == currentPageItem.value.recogFields.length){
          state.assignRecogField = null;
          state.mode = state.ModeEnum.Waku;
          break;
        }else{
          state.assignRecogField = currentPageItem.value.recogFields[nextIdx];
          scrollTableArea(state.assignRecogField);
        }
      }
    };

    /****************************************
     * 設問自動割当て用の順序番号設定
     ****************************************/
    
    const setSortNo = (fieldItems: FieldItem[], num: number, direction: number) => {
      if(direction == state.DirectionEnum.Horizontal){
        const topField = fieldItems.sort((a, b) => a.y - b.y)[0];

        let someFields = fieldItems.filter(f => f.y - topField.y < 15);
        let otherFields = fieldItems.filter(f => !(f.y - topField.y < 15));

        someFields.sort((a, b) => a.x - b.x).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }else if(direction == state.DirectionEnum.VerticalLeft){
        const rightField = fieldItems.sort((a, b) => (b.x + b.width) - (a.x + a.width))[0];

        let someFields = fieldItems.filter(f => (rightField.x + rightField.width) - (f.x + f.width) < 15);
        let otherFields = fieldItems.filter(f => !((rightField.x + rightField.width) - (f.x + f.width) < 15));

        someFields.sort((a, b) => a.y - b.y).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }else{
        const leftmostField = fieldItems.sort((a, b) => a.x - b.x)[0];

        let someFields = fieldItems.filter(f => f.x - leftmostField.x < 15);
        let otherFields = fieldItems.filter(f => !(f.x - leftmostField.x < 15));

        someFields.sort((a, b) => a.y - b.y).forEach(f => {
          f.sortNo = num;
          num += 1;
        });

        if (otherFields.length > 0) {
          setSortNo(otherFields, num, direction);
        }
      }
    };

    /****************************************
     * 設問割当てリセット
     ****************************************/
    
    const resetRecogFields = () => {
      if(!window.confirm("割当を全てリセットします。よろしいですか？")){
        return;
      }
      state.currentRecogField = null;
      allFieldItems.value.forEach(x => x.recogField = null);
      state.assignRecogField = currentPageItem.value.recogFields[0];
      scrollTableArea(state.assignRecogField);
    };

    /****************************************
     * keydown
     ****************************************/

    const keyDown = (e:KeyboardEvent) => {
      
      if(e.key == "ArrowUp"){
        e.preventDefault();

        let recogField: RecogField = null;
        if(state.mode == state.ModeEnum.Waku){
          if(state.currentRecogField == null){
            const idx = currentPageItem.value.recogFields.length - 1;
            recogField = currentPageItem.value.recogFields[idx];
          }else{
            const idx = currentPageItem.value.recogFields.indexOf(state.currentRecogField);
            if(idx > 0){
              recogField = currentPageItem.value.recogFields[idx - 1];
            }
          }
          
          if(recogField){
            changeCurrentRecogField(recogField);
            scrollImageArea(recogField);
            scrollTableArea(recogField)
          }
        }else{
          let recogField: RecogField = null;
          if(state.assignRecogField == null){
            const idx = currentPageItem.value.recogFields.length - 1;
            recogField = currentPageItem.value.recogFields[idx];
          }else{
            const idx = currentPageItem.value.recogFields.indexOf(state.assignRecogField);
            if(idx > 0){
              recogField = currentPageItem.value.recogFields[idx - 1];
            }
          }

          if(recogField){
            state.assignRecogField = recogField;
            scrollImageArea(recogField);
            scrollTableArea(recogField)
          }
        }
      }else if(e.key == "ArrowDown"){
        e.preventDefault();

        if(state.mode == state.ModeEnum.Waku){

          let recogField: RecogField = null;
          if(state.currentRecogField == null){
            recogField = currentPageItem.value.recogFields[0]
          }else{
            const idx = currentPageItem.value.recogFields.indexOf(state.currentRecogField);
            if(idx + 1 < currentPageItem.value.recogFields.length){
              state.multiSelectedFieldItems = new Array<FieldItem>();
              recogField = currentPageItem.value.recogFields[idx + 1];
            }
          }

          if(recogField){
            changeCurrentRecogField(recogField);
            scrollImageArea(recogField);
            scrollTableArea(recogField)
          }
        }else{
          let recogField: RecogField = null;
          if(state.assignRecogField == null){
            recogField = currentPageItem.value.recogFields[0] 
          }else{
            const idx = currentPageItem.value.recogFields.indexOf(state.assignRecogField);
            if(idx + 1 < currentPageItem.value.recogFields.length){
              state.multiSelectedFieldItems = new Array<FieldItem>();
              recogField = currentPageItem.value.recogFields[idx + 1]
            }
          }

          if(recogField){
            state.assignRecogField = recogField;
            scrollImageArea(recogField);
            scrollTableArea(recogField)
          }
        }
      }else if(e.key == "a"){
        if(state.mode == state.ModeEnum.Waku){
          e.preventDefault();
          state.multiSelectedFieldItems = currentPageItem.value.fieldItems;
        }
      }else if(e.key == "c"){
        if(state.mode != state.ModeEnum.Waku){
          return;
        }

        e.preventDefault();
        
        if(state.multiSelectedFieldItems.length > 0){
          // 複数選択中の枠をコピー
          const newMultiSelectedFieldItems = new Array<FieldItem>();
          for(const fieldItem of state.multiSelectedFieldItems){
            const newFieldItem = copyFieldItem(fieldItem);
            newMultiSelectedFieldItems.push(newFieldItem);
          }

          const keys = newMultiSelectedFieldItems.map(x => x.key);
          
          const fieldItems = currentPageItem.value.fieldItems.filter(x => !keys.includes(x.key)).map(x => x);
          currentPageItem.value.fieldItems = newMultiSelectedFieldItems.map(x => x);
          state.multiSelectedFieldItems = newMultiSelectedFieldItems.map(x => x);
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
            clearCurrentItem();  
            state.multiSelectedFieldItems = newMultiSelectedFieldItems;
          });
        }else if(state.currentFieldItem != null){
          // 選択中の枠単体をコピー
          const newFieldItem = copyFieldItem(state.currentFieldItem);
          newFieldItem.isActive = true;

          const fieldItems = currentPageItem.value.fieldItems.filter(x => x != newFieldItem).map(x => x);
          currentPageItem.value.fieldItems = [newFieldItem];
          context.root.$nextTick(() => {
            fieldItems.forEach(x => currentPageItem.value.fieldItems.push(x));
            clearCurrentItem();
            changeCurrentFieldItem(newFieldItem);
          });
        }
      }else if(e.key == "Backspace"){
        if(state.mode == state.ModeEnum.Waku){
          e.preventDefault();
          deleteFieldItem(state.currentFieldItem);
        }
      }else if(e.key == "Shift"){
        e.preventDefault();
        state.isShiftPressed = true;
      }
    }

    /****************************************
     * keyup
     ****************************************/

    const keyUp = (e:KeyboardEvent) => {
      if(e.key == "Shift"){
        e.preventDefault();
        state.isShiftPressed = false;
      }else if(e.key == "Control"){
        e.preventDefault();
        state.isCtrlPressed = false;
      }
    }

    /****************************************
     * 枠自動設定 API呼び出し
     ****************************************/
    
    const recogFieldAutoDetect = async (page: number) => {

      const sheetFields = state.sheetFields.filter(x => x.page == page)

      if(sheetFields.length == 0){
        alert("現在表示中のページにはマーク認識対象がありません。");
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/recog_position_edit/recog_field_auto_detect/${state.sheet_group_key}/${page}`, {sheet_fields: sheetFields}).then(response => {
        let fieldItems = new Array<FieldItem>();
        for(const result_rect of response.data.result_rects){
          let item = new FieldItem();
          item.key = state.key++;
          item.x = result_rect.x;
          item.y = result_rect.y;
          item.width = result_rect.width;
          item.height = result_rect.height;
          fieldItems.push(item);
        }
        state.pageItems[page - 1].fieldItems = fieldItems
        state.currentFieldItem = null;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /****************************************
     * 保存ボタン押下
     ****************************************/
    
    const saveRecogFields = async () => {

      // エラーチェック
      state.errors = [];

      state.pageItems.forEach(pageItem => {
        pageItem.recogFields.forEach(recogField => {
          if(allFieldItems.value.filter((x: FieldItem) => x.recogField && x.recogField.id == recogField.id).length == 0){
            state.errors.push(`${recogField.fieldName} No${recogField.seq_no}の枠が設定されていません。`);
          }else if(allFieldItems.value.filter((x: FieldItem) => x.recogField && x.recogField.id == recogField.id).length > 1){
            state.errors.push(`${recogField.fieldName} No${recogField.seq_no}の枠が複数設定されています。`);
          }
        });
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0 || !window.confirm("認識枠を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      let recogFields = new Array<RecogField>();
      state.pageItems.forEach(pageItem => {
        pageItem.fieldItems.filter(x => x.recogField != null).forEach(fieldItem => {
          fieldItem.recogField.x = fieldItem.x;
          fieldItem.recogField.y = fieldItem.y;
          fieldItem.recogField.width = fieldItem.width;
          fieldItem.recogField.height = fieldItem.height;
          recogFields.push(fieldItem.recogField);
        });
      });

      // id順にソート
      recogFields = recogFields.sort((a, b) => a.id - b.id);

      await http.post(`/api/teacher/recog_position_edit/update/${state.sheet_group_key}`, {recog_fields: recogFields}).then(response => {
        alert("処理が完了しました。");
        if(state.sheet.is_digital_paper){
          context.root.$router.push(`/teacher_site/answer_image_upload/${state.sheet_group_key}`).catch(err => {});
        }else{
          if(context.root.$store.state.sheetType == Common.SheetTypeEnum.Entrance){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(err => {});
          }else if(context.root.$store.state.sheetType == Common.SheetTypeEnum.Practice){
            context.root.$router.push('/teacher_site/practice_sheet_list').catch(err => {});
          }else if(context.root.$store.state.sheetType == Common.SheetTypeEnum.EntranceCompare){
            context.root.$router.push('/teacher_site/entrance_compare_sheet_list').catch(err => {});
          }else if(context.root.$store.state.sheetType == Common.SheetTypeEnum.PracticeCompare){
            context.root.$router.push('/teacher_site/practice_compare_sheet_list').catch(err => {});
          }else{
            context.root.$router.push('/teacher_site/sheet_list').catch(err => {});
          }
          
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /****************************************
     * ページ切り替え
     ****************************************/
    
    const changePage = (page: number) => {
      if(state.mode != state.ModeEnum.Assign){
        clearCurrentItem();
      }
    };

    /****************************************
     * 選択中の枠を複製
     ****************************************/
    
    const copyFieldItem = (baseFieldItem: FieldItem) => {
      let fieldItem = new FieldItem();
      fieldItem.key = state.key++;
      fieldItem.width = baseFieldItem.width;
      fieldItem.height = baseFieldItem.height;
      
      fieldItem.x = baseFieldItem.x;
      fieldItem.y = baseFieldItem.y + baseFieldItem.height;
      
      currentPageItem.value.fieldItems.push(fieldItem);
      return fieldItem;
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;

      // APIで登録済み試験情報取得
      await http.get(`/api/teacher/recog_position_edit?sheet_group_key=${state.sheet_group_key}`).then(async response => {
        
        state.sheet = response.data.sheet;
        state.sheetFields = response.data.sheet_fields;

        if(response.data.sheet.score_positions_completed){

          // ページごとに取得データを仕分ける
          for(let i = 0; i < state.sheet.page_count; i++){
            
            const pageItem = new PageItem(i + 1, response.data.base64_images[i], response.data.image_size_hashes[i].width, response.data.image_size_hashes[i].height);
            for(var recog_field of response.data.recog_fields.filter((x: any) => x.page == i + 1)){
              
              const recogField: RecogField = new RecogField(recog_field);
              pageItem.recogFields.push(recogField);

              if(recogField.is_mark){
                state.isExistsMark = true;
              }

              if(state.sheet.recog_positions_completed){
                if(recogField.width != null && recogField.width > 0 && recogField.height != null && recogField.height > 0){
                  let fieldItem = new FieldItem();
                  fieldItem.key = state.key++;
                  fieldItem.x = recogField.x;
                  fieldItem.y = recogField.y;
                  fieldItem.width = recogField.width;
                  fieldItem.height = recogField.height;
                  fieldItem.recogField = recogField;
                  pageItem.fieldItems.push(fieldItem);
                }
              }
            }
            state.pageItems.push(pageItem);
          }

          // 認識枠設定未完了（初回表示）の場合、枠自動作成
          if(!state.sheet.recog_positions_completed){
            for(let i = 0; i < state.pageItems.length; i++){
              await recogFieldAutoDetect(state.pageItems[i].pageNo);
              console.log("auto detect");
            }
          }
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keydown", keyDown);
      window.addEventListener("keyup", keyUp);

      const tableArea = document.getElementById("table-area");
      const headerLeftArea = document.getElementById("header-left-area");
      headerLeftArea.style.width = `${tableArea.clientWidth}px`;

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      currentPageItem,
      allFieldItems,
      parentW,
      sizeStyle,
      baseFieldStyle,
      recogFieldNamePosStyle,
      isSelected,
      focus,
      adjustHeight,
      adjustWidth,
      scaleUp,
      scaleDown,
      addFieldItem,
      dragStop,
      resizeStop,
      fieldClick,
      trClick,
      deleteFieldItem,
      changeCurrentFieldItem,
      clearCurrentItem,
      resetFieldItems,
      autoAssignRecogFields,
      setSortNo,
      resetRecogFields,
      saveRecogFields,
      changePage,
      copyFieldItem,
      isFieldSettingCompleted,
      changeMode,
      dragging,
      resizing,
      imageAreaPointerDown,
      imageAreaPointerMove,
      imageAreaPointerUp,
      imageAreaPointerLeave,
      recogFieldAutoDetect,
    };
  }
});
